import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import backRed from "../../../../assets/svg/back-rose-icon.svg";
import Breadcrumbs from "../../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import SucessModal from "../../../../components/Modal/SucessModal";
import "./form.scss";

const OthersForm = ({ view = false, edit = false }) => {
  const {
    formState: { errors },
  } = useForm();

  const { id } = useParams();
  const [fields, setFields] = useState({});
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const onSubmit = (fields) => {
    axios
      .post(`${process.env.REACT_APP_API_URL}types/create`, fields)
      .then((response) => {
        if (response.data?._id) {
          setSuccess(true);
        } else {
          alert("Fail");
          console.log("failed...");
        }
      });
  };

  const breadcrumbsList = useMemo(
    () => [
      { text: "Masters", link: "/master-primary-specialisation" },
      { text: "Others", link: "/master-others" },
      { text: "Types", link: "" },
    ],
    [],
  );

  const handleUpdateData = () => {
    let item = { type: fields.type, active: fields.active };
    fetch(`${process.env.REACT_APP_API_URL}types/update/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    }).then((result) => {
      result.json().then((resp) => {
        setSuccess(true);
      });
    });
  };

  const getMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}types/get/${id}`)
      .then((response) => {
        setFields(response.data);
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    (edit || view) && getMenuData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Breadcrumbs
        className="w-75 healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      {/* <Home> */}
      <div
        onClick={() => navigate("/master-others")}
        className="rose back-button"
      >
        <img src={backRed} alt="" />
        <span className="rose-back">Back</span>
      </div>
      <div className="healtharticle">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            edit ? handleUpdateData() : onSubmit(fields);
          }}
          className="carr-dep-form"
        >
          <div className="row car-dep-form">
            <div className="col-5">
              <label
                className="car-dep-form-txt mb-2"
                style={{ color: "#4B4853" }}
                htmlFor=""
              >
                Types <span className="star">*</span>
              </label>
              <input
                className="form-control w-75"
                type="text"
                name=""
                id="type"
                onChange={(e) =>
                  setFields((prevState) => {
                    return { ...prevState, type: e.target.value };
                  })
                }
                placeholder="Type here..."
                value={fields.type}
                disabled={view}
              />
              {errors.type && (
                <div className={`invalid-feedback d-block`}>
                  Please Enter Primary Specialisation
                </div>
              )}
            </div>

            <div className="col-3">
              <label
                className="car-dep-form-txt mb-2"
                style={{ color: "#4B4853" }}
                htmlFor=""
              >
                Active <span className="star">*</span>
              </label>
              <div className="d-flex">
                <div className="form-check form-check-inline me-3 mt-1">
                  <input
                    className="form-check-input me-3"
                    type="radio"
                    name="status"
                    id="status"
                    onChange={(e) => {
                      setFields((prevState) => {
                        return { ...prevState, active: true };
                      });
                    }}
                    disabled={view}
                    value={true}
                    checked={fields.active === true ? "checked" : null}
                  />
                  <label htmlFor="option-1" className="text-dark ">
                    Active
                  </label>
                </div>
                <div className="form-check form-check-inline mt-1">
                  <input
                    className="form-check-input  me-3"
                    type="radio"
                    name="status"
                    id="status"
                    value={false}
                    onChange={(e) => {
                      setFields((prevState) => {
                        return { ...prevState, active: false };
                      });
                    }}
                    disabled={view}
                    checked={fields.active === false ? "checked" : null}
                  />
                  <label htmlFor="option-2" className="text-dark">
                    Inactive
                  </label>
                </div>
              </div>
              {errors.active && (
                <div className={`invalid-feedback d-block`}>
                  Please select an Option
                </div>
              )}
            </div>
          </div>

          {!view && (
            <div className="car-dep-form-button">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                SUBMIT
              </button>
            </div>
          )}
        </form>
      </div>
      {/* </Home> */}
      {success && (
        <SucessModal page={"/master-others"} name="Other Types" post="posted" />
      )}
    </>
  );
};

export default OthersForm;
